import { DatePicker, DatePickerProps } from '@guildeducationinc/recess';
import { useField, FieldInputProps } from 'formik';
import { format } from 'date-fns';
import React from 'react';
import { datadogRum } from '@datadog/browser-rum';

type BaseInputProps = FieldInputProps<string> & DatePickerProps;
type DatePickerFieldProps = BaseInputProps;

const setValueForFormik = (date: string, name: string) => {
  let value = '';
  if (date) {
    try {
      const dateOnly = format(new Date(date), 'yyyy-MM-dd');
      value = dateOnly;
    } catch (error) {
      datadogRum.addError(error, {
        message: `Error formatting date ${date} in DatePickerField`,
      });
    }
  }
  return {
    target: {
      value,
      name,
    },
  };
};

const DatePickerField: React.FC<DatePickerFieldProps> = (props) => {
  const [field, { error, touched, value }] = useField({ name: props.name });

  const { onChange, onBlur } = field;

  return (
    <DatePicker
      {...field}
      {...props}
      errors={touched && error ? error : undefined}
      value={value}
      required={true}
      onChange={(event) => {
        onChange(setValueForFormik(event.target.value, props.name));
      }}
      onBlur={(event) => {
        onBlur(setValueForFormik(event.target.value, props.name));
      }}
    />
  );
};

export default DatePickerField;
